import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const AusgangssituationSkizzeEmob: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0213069123_tuation_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0266237954_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0267605373_on_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0217627076_ssituation_Pruefung_Erledigt.path
				}
				formStruc={PruefAssistenzStruc()}
			/>

			<CreateForm
				formStruc={AusgangSituationStruc()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default AusgangssituationSkizzeEmob;

const PruefAssistenzStruc = (): FormStrucItem[] => {
	return [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0217627076_ssituation_Pruefung_Erledigt,
					label: 'Als erledigt markieren',
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
};
const AusgangSituationStruc = (): FormStrucItem[] => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Stand_Der_Technik_Skizze,
					type: 'markdownEditor',
					placeholder:
						'(Kurzvorstellung Antragsteller und Partner; bisherige Erfahrungen und Kompetenzen in der Elektromobilität; aktueller Stand der Technik; Nachteile bestehender Systeme; Bedarf nach einer neuartigen Lösung)',
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAusgangssituationSkizzeEmob = (application: any, _readOnly: boolean): FormStrucItem[] => {
	const result =
		(
			checkIfPruefAssitenzNeedsToValidate(
				application,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0213069123_tuation_Pruefung_Pruefstatus.path,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0217627076_ssituation_Pruefung_Erledigt.path,
			)
		) ?
			concat(PruefAssistenzStruc(), AusgangSituationStruc())
		:	AusgangSituationStruc();
	return result;
};
